@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css");  
/* /* @import url("../../../node_modules/bootstrap/dist/css/bootstrap.min.css");  */
:host { 
    
     display: block;
}


/*custom */

a , a:visited {
 color: #b71d1d;
 font-size: 16px;
 text-decoration: none;
}


::-webkit-scrollbar {
 width: 2px;
}

/* Handle */
::-webkit-scrollbar-thumb {
 background: #D3D3D3; 
}

.monthday {
    font-size: 20px;
}
.eventdate {
    font-size:13px;
}
